import { render, staticRenderFns } from "./WorkflowUrgencyView.vue?vue&type=template&id=3bb4da8b&scoped=true"
import script from "./WorkflowUrgencyView.vue?vue&type=script&lang=js"
export * from "./WorkflowUrgencyView.vue?vue&type=script&lang=js"
import style0 from "./WorkflowUrgencyView.vue?vue&type=style&index=0&id=3bb4da8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb4da8b",
  null
  
)

export default component.exports